/* 🤖 this file was generated by svg-to-ts */
export const matIconBorderInner: {
  name: 'border-inner';
  data: string;
} = {
  name: 'border-inner',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z"/></svg>`
};
